import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {UsersListService} from 'app/main/pages/users/userslisting/users-list.service';
import {firstValueFrom, Observable} from 'rxjs';
import {User} from '../../pages/contract-control/contract-control-interfaces/cc-activity.interface';
import {SharedStoreFacade} from '../shared/store/shared-store.facade';

@Injectable({
  providedIn: 'root'
})


export class ActivityLogsUtils {

  constructor (
    private sanitizer: DomSanitizer, 
    private userService: UsersListService,
    private _sharedStoreFacade$: SharedStoreFacade
  ) {}

  public loading: boolean = false;
  public users: Observable<User[]> = this._sharedStoreFacade$.users$ as Observable<User[]>;

  public parentCommentStatusBasedStyles = {
    bgColor: '#d4ebff',
    color: '#3380c4',
    bdColor: '#87ceeb',
  };

  /**
   * Load Choices
   * @param searchText
   * @param triggerCharacter
   * @returns 
   */
  async loadUsers({
    searchText,
    triggerCharacter,
  }: {
    searchText: string;
    triggerCharacter: string;
  }): Promise<User[]> {
    let searchResults;
    const users = await firstValueFrom(this.users);
    if (triggerCharacter === '@') {
      searchResults = users;
      return searchResults.filter((user) => {
        return user.name.toLowerCase().includes(searchText.toLowerCase());
      });
    }
    return users;
  }
  



  /**
   * Get Formated HighlightedText
   * @param content 
   * @param ranges 
   * @returns 
   */
  getFormattedHighlightText(
    content: string,
    ranges: {indices}[],
  ) {
    let highlightedContent = content;
    let replaceContentIndex = 0;
    ranges.forEach((range) => {
      const start = range.indices.start;
      const end = range.indices.end;
      const highlightedText = content.substring(start, end);
      const highlighted = `<span style="background-color: ${this.parentCommentStatusBasedStyles.bgColor};color: ${this.parentCommentStatusBasedStyles.color};white-space: nowrap;border: 1px solid ${this.parentCommentStatusBasedStyles.bdColor};padding: 0 3px;border-radius: 3px;">${highlightedText}</span>`;
      const newReplace = highlightedContent
        .substring(replaceContentIndex)
        .replace(highlightedText, highlighted);
      highlightedContent =
        replaceContentIndex === 0
          ? newReplace
          : highlightedContent.substring(0, replaceContentIndex) + newReplace;
      replaceContentIndex = highlightedContent.lastIndexOf('</span>') + 7;
    });

    highlightedContent = highlightedContent.replace(/\n/g, '<br>');
    return this.sanitizer.bypassSecurityTrustHtml(
      highlightedContent
    ) as string;
  }
}
